module.exports = __webpack_public_path__ + "static/4-9c89c81c1b074457f4557c0829cbad27.png";